import { SourceLinks } from '@/components/ui/source-links';
import { Users } from 'lucide-react';
import { DiscoveryCard } from './discovery-card';
import { useState } from 'react';

interface DailyLifeCardProps {
    dailyLife: {
        housing: string;
        diet: string;
        clothing: string;
        economy: string;
        socialCustoms: string;
        sources?: Source[];
    };
    isExpanded?: boolean;
    onToggleExpansion?: () => void;
    defaultExpanded?: boolean;
    title?: string;
}

export function DailyLifeCard({
    dailyLife,
    isExpanded: controlledIsExpanded,
    onToggleExpansion: controlledOnToggleExpansion,
    defaultExpanded = false,
    title = "Daily Life"
}: DailyLifeCardProps) {
    const [internalIsExpanded, setInternalIsExpanded] = useState(defaultExpanded);

    const isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : internalIsExpanded;
    const onToggleExpansion = controlledOnToggleExpansion !== undefined
        ? controlledOnToggleExpansion
        : () => setInternalIsExpanded(!internalIsExpanded);

    const Section = ({ title, content }: { title: string; content: string }) => (
        <div className="space-y-1.5 border-l border-primary/10 pl-4">
            <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">{title}</div>
            <p className="text-sm text-foreground/70 font-light leading-relaxed">{content}</p>
        </div>
    );

    return (
        <DiscoveryCard
            isExpanded={isExpanded}
            onToggle={onToggleExpansion}
            title={title}
            icon={Users}
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                <Section title="Housing" content={dailyLife.housing} />
                <Section title="Diet" content={dailyLife.diet} />
                <Section title="Clothing" content={dailyLife.clothing} />
                <Section title="Economy" content={dailyLife.economy} />
                <div className="md:col-span-2">
                    <Section title="Social Customs" content={dailyLife.socialCustoms} />
                </div>
            </div>
            {dailyLife.sources && dailyLife.sources.length > 0 && (
                <div className="pt-4 border-t border-border/10">
                    <SourceLinks sources={dailyLife.sources} />
                </div>
            )}
        </DiscoveryCard>
    );
}
